import { useEffect, useState } from 'react'
import styled from 'styled-components'
import useAtomWithRef from '../../../utils/useAtomWithRef'
import { formatTime } from '../../../utils/videojs'
import { videoElementAtom } from './atoms'

//* =========================== React Component ================================

const RemainingTimeDisplay = (): JSX.Element => {
  const [remaining, setRemaining] = useState('0:00')
  const [videoElementRef, videoElement] = useAtomWithRef(videoElementAtom)

  useEffect(() => {
    if (!videoElement) {
      return
    }
    videoElement.addEventListener('timeupdate', () => {
      const remainingTime = videoElementRef.current!.duration - videoElementRef.current!.currentTime
      setRemaining(formatTime(remainingTime, remainingTime))
    })
    videoElement.addEventListener('loadedmetadata', () => {
      setRemaining(formatTime(videoElementRef.current!.duration, videoElementRef.current!.duration))
    })
  }, [videoElement])

  return (
    <Wrapper>
      <TimeText>{`-${remaining}`}</TimeText>
    </Wrapper>
  )
}

export default RemainingTimeDisplay

//* ============================== Styled Components ===========================

const TimeText = styled.div`
  color: #ffffff;
  font-weight: 400;
  font-size: 15px;
  white-space: nowrap;
`

const Wrapper = styled.div`
  user-select: none;
`
